import { render, staticRenderFns } from "./AdFoot.vue?vue&type=template&id=4c5235c6&scoped=true"
import script from "./AdFoot.vue?vue&type=script&lang=ts"
export * from "./AdFoot.vue?vue&type=script&lang=ts"
import style0 from "./AdFoot.vue?vue&type=style&index=0&id=4c5235c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5235c6",
  null
  
)

export default component.exports